import ContentItemWithResolver from 'models/ContentItemWithResolver';
import get from 'lodash/get';
import KENTICO_TYPES from 'common/consts/kentico-types';
import { FieldModels } from 'kentico-cloud-delivery/_es2015';
import AssetModel = FieldModels.AssetModel;

export default class SmallColumnModel extends ContentItemWithResolver {
	static readonly type = KENTICO_TYPES.SMALL_COLUMN;

	get image(): AssetModel {
		return get(this, '_image.assets[0]', null);
	}

	get text(): string {
		return get(this, '_text.value', '');
	}
}
